import { createContext, useReducer } from 'react'

export const needsAttentionInitialState = { caseIds: [] }

export const NeedsAttentionContext = createContext()

const needsAttentionReducer = (state, action) => {
  switch (action.type) {
    case 'update':
      return {
        ...state,
        caseIds: [...action.data],
      }
    case 'reset':
      return {
        ...needsAttentionInitialState,
      }
    default:
      throw new Error('Unexpected action')
  }
}

export const NeedsAttentionProvider = (props) => {
  // pass in the state using props (useful in testing) or use the appInitialState
  const state = props.state || needsAttentionInitialState
  const reducer = useReducer(needsAttentionReducer, state)
  return (
    <NeedsAttentionContext.Provider value={reducer}>
      {props.children}
    </NeedsAttentionContext.Provider>
  )
}

export const NeedsAttentionConsumer = NeedsAttentionContext.Consumer
